import {
  SITE_LEAD_REFERRAL_LIST,
  SITE_LEAD_REFERRAL_SPOC_LIST,
  SITE_LEAD_REFERRAL_REJECT_REASONS,
  SITE_LEAD_REFERRAL_STATUS_HISTORY,
} from './type';

const emptySpocOptions = { regionOptions: [], spocOptionsByRegion: {} };

const initialState = {
  referralList: { referrals: [], count: 0, page: 1, limit: 20, incentiveAmounts: null },
  spocOptions: emptySpocOptions,
  rejectReasons: [],
  statusHistory: [],
};

export default function siteLeadReferralReducer(state = initialState, action) {
  switch (action.type) {
    case SITE_LEAD_REFERRAL_LIST:
      return { ...state, referralList: action.payload };
    case SITE_LEAD_REFERRAL_SPOC_LIST:
      return { ...state, spocOptions: action.payload };
    case SITE_LEAD_REFERRAL_REJECT_REASONS:
      return { ...state, rejectReasons: action.payload };
    case SITE_LEAD_REFERRAL_STATUS_HISTORY:
      return { ...state, statusHistory: action.payload };
    default:
      return state;
  }
}
